import React from 'react';
import PageTitle from '../components/PageTitle';
import TeamCarousel from '../components/about/TeamCarousel';
import OurStory from '../components/about/OurStory';
import OurPassion from '../components/about/OurPassion';
import GridCTA from '../components/GridCTA';

const AboutUsPage = () => {
    return (
        <main id="infocolors-main">
            <div className="stg-container">
                <PageTitle
                    title="About Us"
                    subtitle="Welcome to INFOCOLORS, Home of Creativity Out of this World 👽 ."
                />

                <section className="divider-bottom">
                    <div className="infocolors-parallax-media stg-bottom-gap-l" data-appear="fade-up" data-delay="200" data-unload="fade-up">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/about-us.jpg" alt="About infocolors" width="1920" height="960" />
                    </div>
                    <div className="stg-row stg-large-gap stg-tp-normal-gap">
                        <div className="stg-col-6 stg-vertical-space-between stg-tp-bottom-gap-l" data-unload="fade-left">
                            <h2 data-split-appear="fade-up">Capturing the Creative World.</h2>
                            <div className="align-right" data-appear="fade-right">
                                <a href="https://www.instagram.com/the_infocolors/" className="infocolors-icon-link">
                                    <div className="infocolors-icon-link-content">
                                        <h6>
                                            Unleash your
                                            <br />
                                            Brand's potential
                                        </h6>
                                        <span className="infocolors-label">Explore our work</span>
                                    </div>
                                    <div className="infocolors-icon-wrap">
                                        <i className="infocolors-icon infocolors-icon-explore"></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="stg-col-6" data-appear="fade-left" data-unload="fade-right" data-delay="100">
                            <p className="infocolors-large-text"> As a dynamic multi-platform media brand, we connect you to the creative and artistic heart of the world, transforming your ideas into stunning visual realities.</p>
                            <p>At INFOCOLORS, we're more than just a media company; we're a dynamic, multi-platform brand dedicated to connecting people to the vibrant creative and artistic pulse of the world. We operate at the fascinating intersection of art, creativity, and media, building a space where talented artists, visionary creators, and compelling stories can truly shine for a global audience.</p>
                            <p>INFOCOLORS stands out through our unwavering dedication to fostering a supportive environment for creatives, our strong focus on authentic storytelling, and our commitment to delivering exceptionally high-quality visual content.</p>
                            <p>We're more than a service provider; we're a creative and informational movement. Join us as we continue our mission to reshape how creativity and information are shared, bringing art, culture, and knowledge into the lives of people everywhere.</p>
                        </div>
                    </div>
                </section>

                <TeamCarousel />
                <OurStory />
                <OurPassion />
                <GridCTA />
            </div>
        </main>
    );
};

export default AboutUsPage;
